import $ from 'jquery';

$(document).ready(() => {

	$(document).on('lity:open', function(event, instance) {
		$('.modal-gallery').slick('setPosition');

		$('.js-lity-close').on('click', function(event){
			event.preventDefault();
			instance.close();
		});
	});

});
